<template>
  <layout-default>
    <span slot="title">{{ fullName }}</span>
    <div class="row">
      <div class="col">
        <router-link
          to="/user"
          tag="button"
          type="button"
          class="inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white transition duration-150 ease-in-out bg-gray-400 hover:bg-gray-400 focus:outline-none focus:shadow-outline-gray focus:border-gray-600 active:bg-gray-600"
        >
          <font-awesome-icon
            :icon="['fad', 'backward']"
            size="lg"
            fixed-width
          />
        </router-link>
      </div>
    </div>
    <div class="mt-4">
      <label
        for="name"
        class="block text-sm font-medium leading-5 text-gray-700"
        >User Name</label
      >
      <div class="mt-1 relative rounded-md shadow-sm">
        <input
          v-model="user.name"
          type="text"
          id="name"
          class="form-input block w-full sm:text-sm sm:leading-5"
        />
      </div>
    </div>
    <div class="mt-4">
      <label
        for="first"
        class="block text-sm font-medium leading-5 text-gray-700"
        >First Name</label
      >
      <div class="mt-1 relative rounded-md shadow-sm">
        <input
          v-model="user.first"
          type="text"
          id="first"
          class="form-input block w-full sm:text-sm sm:leading-5"
        />
      </div>
    </div>
    <div class="mt-4">
      <label
        for="last"
        class="block text-sm font-medium leading-5 text-gray-700"
        >Last Name</label
      >
      <div class="mt-1 relative rounded-md shadow-sm">
        <input
          v-model="user.last"
          type="text"
          id="last"
          class="form-input block w-full sm:text-sm sm:leading-5"
        />
      </div>
    </div>
    <div class="mt-4">
      <label
        for="email"
        class="block text-sm font-medium leading-5 text-gray-700"
        >Email Address</label
      >
      <div class="mt-1 relative rounded-md shadow-sm">
        <input
          v-model="user.email"
          type="email"
          id="email"
          class="form-input block w-full sm:text-sm sm:leading-5"
        />
      </div>
    </div>
    <div class="mt-4">
      <label
        for="password"
        class="block text-sm font-medium leading-5 text-gray-700"
        ><span v-if="id < 0">New </span>Password</label
      >
      <div class="mt-1 relative rounded-md shadow-sm">
        <input
          v-model="user.password"
          type="password"
          id="password"
          class="form-input block w-full sm:text-sm sm:leading-5"
        />
      </div>
    </div>
    <div class="grid grid-cols-2 gap-4 mt-4">
      <div class="text-center">
        <button
          @click.prevent="save"
          tag="button"
          type="button"
          class="items-center p-4 border border-transparent text-sm leading-5 font-medium rounded-md text-white transition duration-150 ease-in-out bg-blue-400 hover:bg-blue-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-600 active:bg-blue-600"
        >
          <font-awesome-icon
            :icon="['fad', 'user-edit']"
            size="lg"
            fixed-width
          />
          Save
        </button>
      </div>
      <div class="text-center">
        <button
          @click.prevent="cancel"
          tag="button"
          type="button"
          class="items-center p-4 border border-transparent text-sm leading-5 font-medium rounded-md text-white transition duration-150 ease-in-out bg-gray-400 hover:bg-gray-400 focus:outline-none focus:shadow-outline-gray focus:border-gray-600 active:bg-gray-600"
        >
          <font-awesome-icon
            :icon="['fad', 'user-times']"
            size="lg"
            fixed-width
          />
          Cancel
        </button>
      </div>
    </div>
  </layout-default>
</template>
<script>
import LayoutDefault from "@/components/layouts/LayoutDefault.vue";

export default {
  name: "User",
  components: {
    LayoutDefault
  },
  data() {
    return {
      user: {}
    };
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  computed: {
    fullName() {
      if (this.user.first || this.user.last) {
        return this.user.first + " " + this.user.last;
      }
      return "Add New User";
    }
  },
  methods: {
    save() {
      if (this.id > 0) {
        this.$store.dispatch("updateUser", this.user);
      } else {
        this.$store.dispatch("addUser", this.user);
      }
      this.$router.push("/user");
    },
    cancel() {
      this.$router.push("/user");
    }
  },
  created() {
    if (this.id > 0) {
      this.$store.dispatch("getUsers");
      this.user = this.$store.state.users.find(
        user => user.id === Number(this.id)
      );
    }
  }
};
</script>
